/**************************************************************************************************************************************************
*   MODULE NAME     :  APIInterceptor
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  08-02-2021
*   DESCRIPTION     :  Common API interceptor
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2467262
*   DESCRIPTION: <GLSD>: Node 20 Upgrade and Implement MSAL
*   DATE: 29-Jan-2025
/**************************************************************************************************************************************************/

import Axios from 'axios';
import * as actionTypes from "../actions/actionTypes";
import { AuthProvider } from "../auth/index"
import config from "../config.json";

const interceptor = (store) => {
  Axios.interceptors.request.use(
    async (conf) => {
      // Set Default Logged In Parameters in the request data
        let loggedUserDetail = store.getState().userDataReducer.loggedUserDetail;
        let authProvider = store.getState().userDataReducer.authProvider;
        if(loggedUserDetail){
          conf.data['createdBy'] = loggedUserDetail.userClientId;
          conf.data['updatedBy'] = loggedUserDetail.userClientId;
          conf.data['createdAt'] = +new Date();
          conf.data['updatedAt']= +new Date();
        }  
  
      // Dispatch action to show loading spinner
      store.dispatch({
        type:actionTypes.SHOW_LOADER,
        showLoader: true,        
      });
      // you can add some information before send it.
      if(authProvider) {
        let url = conf.url.split("/");
        url.pop();
        let urlString = url.join("/");
        if(urlString === config.Backend_URL) {
          let gatewayToken = await authProvider.getGatewayAccessToken();
          conf.headers['Authorization'] = 'Bearer ' + gatewayToken.accessToken;
        }
      }
      return conf;
    },
    (error) => {
      console.log({error})
      console.log(error && error.response && error.response.data ? error.response.data: {});
      return Promise.reject(error);
    }
  );
  Axios.interceptors.response.use(
    (next) => {
      
      store.dispatch({
        type:actionTypes.HIDE_LOADER,
        showLoader: false,        
      });

      return Promise.resolve(next);
    },
    (error) => {
      console.log({error});
      console.log(error && error.response && error.response.data ? error.response.data: {});
      store.dispatch({
        type:actionTypes.HIDE_LOADER,
        showLoader: false,        
      });
     
      // You can handle error here and trigger warning message without get  in the code inside
      store.dispatch({
        type:actionTypes.OPEN_WARNING_MODAL,
        message: error.message,        
      });
      return Promise.reject(error);
    }
  );
};
export default {
  interceptor,
};
